import React, {useState} from 'react';
import Cookies from 'js-cookie';
import {Dialog, Flex, Button} from '@priority-software/priority-style-react';
import {DialogContent} from './DialogContent';
import styles from './AccountsDialog.module.scss';
import {Message, messageTypeText} from './consts';
import {getHardcodedText, DialogText, monitorText, accountsAlertCookie} from './consts';
import AccountsDlgImg from '../../images/accountsDlgImg.svg';
import {monitorTransaction} from '../../utils/monitoring';

export const AccountsDialog = () => {
    const [isOpen, setIsOpen] = useState<boolean>(true);

    const onAccept = () => {
        monitorTransaction(monitorText);
        // Create a Date for tomorrow at 6:00 AM (GMT time)
        const expireAt = new Date();
        expireAt.setDate(expireAt.getDate() + 1); // Move to next day
        expireAt.setHours(6, 0, 0, 0); // Set time to 6 AM
        Cookies.set(accountsAlertCookie, '1', {expires: expireAt});
        setIsOpen(false);
    };

    const message: Message = (window as any)?.priorityMessage;
    const shouldExecute = message?.type === messageTypeText && message.details;

    return shouldExecute ? (
        <Dialog
            isOpen={isOpen}
            closable={false}
            maskClosable={false}
            componentClasses={styles.dialogWrapper}
            content={
                <Flex direction="column" componentClasses={styles.dialogContent}>
                    <div className={styles.imageWrapper}>
                        <img src={AccountsDlgImg} className={styles.cardImage} />
                    </div>
                    <DialogContent details={message.details} />
                    <Button wideButton componentClasses={styles.acceptBtn} onClick={onAccept}>
                        {getHardcodedText(DialogText.acceptBtn)}
                    </Button>
                </Flex>
            }
        />
    ) : null;
};
